<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="specialist">
					<dl>
						<dd v-for="(item,index) in list" :key="index" @click="specialistTo(item)">
							<div class="specialist-pic">
								<div class="imgbox_a imgbox_hover">
									<img :src="icoURL+'storage/'+item.image" alt="">
								</div>
							</div>
							<div class="specialist-con">
								<h1 class="tver"><span>{{item.title}}</span></h1>
								<h2 class="tver">{{item.sub_title}}</h2>
							</div>
						</dd>
					</dl>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'specialist',
		data(){
			return{
				title:'',
				titleEn:'',
				list:[],
			}
		},
		methods:{
			res_menuClass(e){
				this.axios.get('/api/menus/class?id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.title = response.data.reslut.name;
							this.titleEn = response.data.reslut.sub_title;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_list(e){
				this.axios.get("/api/news/listNews?category_id="+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.list = response.data.reslut;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			specialistTo(e){
				$('html, body').animate({ scrollTop: 0 }, 0);
				this.$router.push({
					path:'/slider/'+this.$route.params.id+'/specialist_detail',
					query:{
						category_id:e.category_id,
						id:e.id
					}
				})
			}
		},
		created() {
			this.res_menuClass(this.$route.query.category_id);
			this.res_list(this.$route.query.category_id);
		}
	}
</script>

<style>
</style>